<template>
  <dropzone
    class="referral-preview bg-light h-100_"
    :class="{ 'with-sidbar-expanded': isRightBarExpanded }"
    @drop="drop"
  >
    <template v-if="item">
      <!-- <div class=" d-flex justify-content-between mb-3 " style="font-size:.85rem">
      <filter-item text="Referral Details" @click="activeTab = 'referral'" :isActive="activeTab == 'referral'" />
      <filter-item text="Attachments" @click="activeTab = 'attachments'" :isActive="activeTab == 'attachments'" />
      <filter-item text="History &amp; Notes" @click="activeTab = 'notes'" :isActive="activeTab == 'notes'" />
      <filter-item v-if="user.practice.sms_number" text="Patient Messaging" />
    </div> -->
      <!-- <filter-item text="History &amp; Notes" @click="activeTab = 'notes'" :isActive="activeTab == 'notes'" /> -->
      <div class="d-flex h-100">
        <template v-if="activeTab == 'referral'">
          <div class="view-referral-wrapper d-flex mx-auto flex-grow-1" style="background: var(--light-color)">
            <div class="d-flex w-100">
              <div ref="mainContainer" class="d-flex flex-column h-100 flex-grow-1">
                <transition name="fade" mode="out-in">
                  <!-- todo: make this a send option -->
                  <div
                    ref="callBanner"
                    v-if="isRequestToCallBannerShown"
                    v-show="isScrolledPassedHeader"
                    class="alert alert-info mb-0 fixed-alert text-center font-weight-bold"
                    style="font-size: 1rem; border-radius: 0"
                  >
                    {{ $helpers.doctor(item) }} is requesting you
                    <b
                      >call {{ item.patient_firstname }} {{ item.patient_lastname }} at
                      {{ item.patient_phone | phone }}</b
                    >
                    and schedule an appointment
                  </div>
                  <div
                    v-if="!item.is_marked_scheduled && item.requested_scheduled_time"
                    v-show="isScrolledPassedHeader"
                    class="alert alert-info fixed-alert mb-0 text-center font-weight-bold"
                    style="font-size: 1rem; border-radius: 0"
                  >
                    {{ item.patient_firstname }} {{ item.patient_lastname }} has requested an appointment, please
                    <b>call them at {{ item.patient_phone | phone }}</b> and schedule an appointment
                  </div>
                  <div
                    v-if="isRequestForUpdateBannerShown"
                    class="alert alert-primary mb-0 text-center font-weight-bold"
                    style="font-size: 1rem; border-radius: 0"
                  >
                    Thanks for contacting {{ item.patient_firstname }} {{ item.patient_lastname }} - please let
                    {{ $helpers.doctor(item) }} know if an appointment was made
                  </div>
                  <div
                    v-if="
                      item.is_incoming &&
                      item.is_marked_scheduled &&
                      !(item.scheduled_time || item.completed_time || !item.is_important)
                    "
                    class="alert alert-primary mb-0 text-center font-weight-bold"
                    style="font-size: 1rem; border-radius: 0"
                  >
                    Provide an appointment time for helpful insights and updates
                  </div>
                  <!--  -->
                </transition>
                <div ref="scrollContent" class="preview-area-overflow overflow-auto pt-3" style="">
                  <!-- <div class="d-none _d-flex mx-auto py-1 mx-auto px-6" style="max-width: 1080px; opacity:.8; justify-content: space-between;">
                    <div class="text-center">
                      <div class="circle border-primary">
                        <font-awesome-icon size="3x" class="text-primary" :icon="['far', 'eye']" />
                        <h5 class="text-primary mt-2">Viewed</h5>
                      </div>
                    </div>
                    <div class=" text-center">
                      <div class="circle">
                        <font-awesome-icon size="3x" class="text-border" :icon="['fas', 'phone']" />
                        <h5 class="text-border mt-2">Called</h5>
                      </div>
                    </div>
                    <div class=" text-center">
                      <div class="circle">
                        <font-awesome-icon size="3x" class="text-border" :icon="['far', 'calendar']" />
                        <h5 class="text-border mt-2">Scheduled</h5>
                      </div>
                    </div>
                    <div class=" text-center">
                      <div class="circle">
                        <font-awesome-icon size="3x" class="text-border" :icon="['far', 'file-medical']" />
                        <h5 class="text-border mt-2">Op Report</h5>
                      </div>
                    </div>
                  </div> -->
                  <indicator :referralId="item.id" />
                  <div class="py-3 mx-auto px-5" style="max-width: 1080px">
                    <div class="bg-white mx-auto d-block" style="margin-bottom: 30px">
                      <PrintReferral
                        ref="viewReferral"
                        v-if="item.sent_time"
                        :referralId="item.id"
                        :showInsurance="true"
                        :isAutoPrint="false"
                        :isImportant="isRequestToCallBannerShown"
                        :isUploadEnabled="true"
                        @uploaded="onUploadAttachment"
                      />
                      <!-- <router-view v-else /> -->
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="showSidebar"
                class="overflow-hidden"
                :style="{
                  'max-width': isRightBarExpanded ? '350px' : 'auto',
                  'min-width': isRightBarExpanded ? '350px' : '50px',
                }"
              >
                <ReferralRightBar
                  @toggle="toggleRightBar"
                  @hide="toggleRightBar(false)"
                  :isExpanded="isRightBarExpanded"
                  :isExpandable="true"
                  :referralId="item.id"
                />
                <!-- <div class="d-flex flex-column h-100">
                  <div class="progress-indicator d-flex py-3" style="max-width: 1080px; opacity:.8; justify-content: space-between;">
                    <div class="text-center active">
                      <div class="circle ">
                        <font-awesome-icon size="lg" class="" :icon="['far', 'eye']" />
                      </div>
                      <h5 class="mt-2">Viewed</h5>
                    </div>
                    <div class=" text-center active">
                      <div class="circle ">
                        <font-awesome-icon size="lg" class="" :icon="['fas', 'phone']" />
                      </div>
                      <h5 class=" mt-2">Called</h5>
                    </div>
                    <div class=" text-center">
                      <div class="circle">
                        <font-awesome-icon size="lg" class="" :icon="['far', 'calendar']" />
                      </div>
                      <h5 class=" mt-2">Treatment</h5>
                    </div>
                    <div class=" text-center">
                      <div class="circle">
                        <font-awesome-icon size="lg" class="" :icon="['far', 'file-medical']" />
                      </div>
                      <h5 class=" mt-2">Report</h5>
                    </div>
                  </div>
                  <div class="p-5"></div>
                  <referral-notes :item="item" class="flex-grow-1" />
                </div> -->
              </div>
            </div>
          </div>
          <!-- <div class="row">
        <div class="col-12 col-sm-7">

          <div class="row mb-2">
            <div class="col-12 col-sm-5 text-muted">
              Patient
            </div>
            <div class="col-12 col-sm-7 font-weight-bolder">
              {{displayName}}
            </div>
          </div>

          <div class="row mb-2" v-if="item.patient_dob">
            <div class="col-12 col-sm-5 text-muted">
              Date of birth
            </div>
            <div class="col-12 col-sm-7 font-weight-bold">
              {{dob}}
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-12 col-sm-5 text-muted">
              Phone
            </div>
            <div class="col-12 col-sm-7 font-weight-bold">
              {{item.patient_phone | phone}}
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-12 col-sm-5 text-muted">
              Insurance
            </div>
            <div class="col-12 col-sm-7 font-weight-bold">
              Delta 154-454-5464
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-12 col-sm-5 text-muted">
              Reason for referral
            </div>
            <div class="col-12 col-sm-7 font-weight-bold">
              {{
              modelReasons
                ? modelReasons.map((kv) => kv.value).join(', ')
                : 'No Reason Provided'
            }}
            </div>
          </div>

          <div class="row mb-2" v-if="item.comments">
            <div class="col-12 col-sm-5 text-muted">
              Comment
            </div>
            <div class="col-12 col-sm-7 font-weight-bold">
              {{item.comments}}
            </div>
          </div>

          <div class="row mb-1">
            <div class="col-12 col-sm-5 text-muted">
              Teeth
            </div>
            <div class="col-12 col-sm-7 font-weight-bold">
              <span class="d-block" v-html="$helpers.formatToothList(tooth_list, 'd-block')"></span>
            </div>
          </div>

        </div>
        <div class="col-12 col-sm-5">
          <tooth-picker v-model="item.teeth" :disabled="true" viewBox="0 40 473.4 577.04" />
        </div>
      </div> -->
        </template>
        <template v-if="activeTab == 'attachments'">
          <div class="py-3 mx-auto px-5 flex-grow-1" style="max-width: 1080px">
            <referral-attachments :item="item" class="" />
          </div>
        </template>
        <template v-if="activeTab == 'notes'">
          <div class="py-3 mx-auto px-5 flex-grow-1" style="max-width: 1080px">
            <referral-notes :item="item" class="flex-grow-1" />
          </div>
        </template>
        <!-- <div class="section-tabs d-flex flex-column px-3 mr-3">
        <font-awesome-icon @click="activeTab = 'referral'" :class="activeTab == 'referral' ? 'text-primary' : 'text-hint'" :icon="['far', 'file-medical']" size="3x" />
        <font-awesome-icon @click="activeTab = 'attachments'" :class="activeTab == 'attachments' ? 'text-primary' : 'text-hint'" :icon="['far', 'paperclip']" size="3x" class="my-4" />
        <font-awesome-icon @click="activeTab = 'notes'" :class="activeTab == 'notes' ? 'text-primary' : 'text-hint'" :icon="['far', 'comment-alt-dots']" size="3x" />

        <router-link class="mt-4" :to="'/referral/print/' + item.id" title="Print Referral" target="_blank">
          <font-awesome-icon class="text-hint" :icon="['far', 'print']" size="3x" />
        </router-link>
        <div class="mt-4" @click="downloadPdf" title="Download Referral" :disabled="isDownloadingPdf">
          <font-awesome-icon icon="spinner-third" spin v-if="isDownloadingPdf" />
          <template v-else>
            <font-awesome-icon :icon="['far', 'download']" class="text-hint" size="3x" />
          </template>
        </div>
      </div> -->
      </div>

      <attach-op-report-modal
        v-if="item.is_incoming && isAttachingOpReportModalVisible"
        :item="item"
        @close="isAttachingOpReportModalVisible = false"
        @send="createAndSendOpReport"
      />
    </template>
  </dropzone>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import ReferralMenu from '../ReferralMenu.vue'
import ToothPicker from '../../ToothPicker.vue'
import FilterItem from '../list/FilterItem.vue'
import ReferralAttachments from './ReferralAttachments.vue'
import ReferralNotes from './ReferralNotes.vue'
import ScheduledButton from '@/components/referrals/ScheduleButton'
import PrintReferral from '@/views/referrals/PrintReferral'
import Dropzone from '../../shared/Dropzone.vue'
import ReferralRightBar from '@/components/referrals/rightbar/ReferralRightBar.vue'
import Indicator from './Indicator.vue'
import { AttachmentApi } from '../../../services'
import AttachOpReportModal from '../AttachOpReportModal.vue'
export default {
  components: {
    ReferralMenu,
    ToothPicker,
    FilterItem,
    ReferralAttachments,
    ReferralNotes,
    ScheduledButton,
    PrintReferral,
    Dropzone,
    ReferralRightBar,
    Indicator,
    AttachOpReportModal,
  },
  props: {
    item: {
      type: Object,
      required: false,
    },
    showSidebar: { default: true },
  },
  data() {
    return {
      activeTab: 'referral',
      uploads: [],
      isNotesVisible: true,
      isRightBarExpanded: false,
      isScrolledPassedHeader: false,
      isAttachingOpReportModalVisible: false,
      lastUploadedFile: null,
    }
  },
  created() {
    // this.handleDebouncedScroll = this.$helpers.debounce(this.handleScroll, 50)
    window.addEventListener('resize', this.handleScrollAndResize)
  },
  mounted() {
    document.getElementsByClassName('preview-area-overflow')[0].addEventListener('scroll', this.handleScrollAndResize)
    this.markViewed() //todo: make sure this triggers on route change
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleScrollAndResize)
    document
      .getElementsByClassName('preview-area-overflow')?.[0]
      ?.removeEventListener('scroll', this.handleScrollAndResize)
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('settings', ['PracticeTypes', 'FlatReasons']),
    displayName() {
      return `${this.item.patient_lastname || ''}, ${this.item.patient_firstname || ''}`
    },
    sender() {
      return `from Dr. ${this.item.referring_doctor.first_name} ${this.item.referring_doctor.last_name} (${this.item.practice.name})`
    },
    time() {
      return moment(this.item.sent_time || this.item.updated_at)
    },
    displayTime() {
      return this.time.format('ll')
    },
    timeAgo() {
      return this.time.fromNow()
    },
    isSchedulable() {
      return this.$helpers.isSchedulable(this.item) && !this.item.scheduled_time
    },
    dob() {
      return this.item.patient_dob && moment(this.item.patient_dob).format('LLL')
    },
    referralType() {
      return this.PracticeTypes[this.item.to_practice.specialty]
    },
    referralReasons() {
      if (this.referralType === null) return
      return this.FlatReasons
    },
    modelReasons() {
      if (!this.item.reasons.length) return
      const reasons = this.referralReasons
      return (
        reasons &&
        this.item.reasons.map((key) => ({
          key,
          value: key in reasons ? reasons[key] : key,
        }))
      )
    },
    tooth_list: function () {
      if (!this.item?.teeth?.length) return []
      // provide natural sort for numbers, probably not the most desired solution
      // Deciduous teeth (A,B,C etc) will be ordered within Quandrant (LL, UR etc)
      const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'base',
      })
      let teeth = [].slice.call(this.item.teeth)
      teeth.sort(collator.compare)
      return teeth
    },
    isRequestToCallBannerShown() {
      return (
        this.$helpers.isSchedulable(this.item) &&
        !this.item.is_marked_scheduled &&
        this.item.is_incoming &&
        !this.item.patient_called_on &&
        this.item.is_important
        //!this.$helpers.isSnoozed(this.referral)
      )
    },
    isRequestForUpdateBannerShown() {
      const r = this.item
      return r.is_incoming && r.patient_called_on && !r.snooze_until_to_time && !r.is_marked_scheduled && r.is_important
    },
  },
  methods: {
    handleScrollAndResize(event) {
      //todo: should handle resize event too - ideally a pure css way would be nice but tough to avoid flicker
      const isVisible =
        this.$refs.scrollContent.scrollTop >=
        document.getElementsByClassName('mark-important-alert')?.[0]?.getBoundingClientRect().y // 198

      //if (isVisible && !this.isScrolledPassedHeader) {
      this.setAlertBannerWidth()
      // }
      this.isScrolledPassedHeader = isVisible // window.scrollY > 500
    },
    setAlertBannerWidth() {
      if (!this.$refs.callBanner?.style) return
      this.$refs.callBanner.style.width = this.$refs.mainContainer.scrollWidth + 'px'
    },
    toggleRightBar(isExpanded) {
      this.isRightBarExpanded = typeof isExpanded === 'boolean' ? isExpanded : !this.isRightBarExpanded

      this.$nextTick(this.setAlertBannerWidth)

      this.$track(this.isRightBarExpanded ? '$showRightBar' : '$hideRightBar')
    },
    drop(e) {
      e.preventDefault()
      if (e.dataTransfer) {
        this.$refs.viewReferral.$refs.attachments.$refs.upload.$refs.upload.addDataTransfer(e.dataTransfer)
      }
    },
    markViewed() {
      try {
        if (this.item?.receiver_viewed_at_time || !this.item?.is_incoming) return
        //todo: endpoint for this which checks user ss
        this.$store.dispatch('referrals/save', {
          ...this.item,
          receiver_viewed_at_time: moment().utc().toISOString(),
        })
      } catch (er) {
        console.error(er)
      }
    },
    async onUploadAttachment(file) {
      //check for op report
      const documentTypes = [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      ]
      if (!this.item?.is_incoming || !documentTypes.includes(file?.type)) return

      this.isAttachingOpReportModalVisible = true
      this.lastUploadedFile = file
    },
    async createAndSendOpReport(referring_doctor_id) {
      try {
        const now = moment.utc()
        this.isAttachingOpReportModalVisible = false

        const opReport = await this.$store.dispatch('opreports/save', {
          referring_doctor_id,
          to_practice_id: this.item.practice_id,
          patient_dob: this.item.patient_dob,
          teeth: this.item.teeth,
          patient_firstname: this.item.patient_firstname,
          patient_lastname: this.item.patient_lastname,
          referral_id: this.item.id,
          sent_time: now,
        })

        const attachment = await AttachmentApi.patch(this.lastUploadedFile.response.id, {
          opreport: opReport.id,
          document_type: 2,
        })

        this.$store.dispatch('referrals/attach', {
          referralId: this.item.id,
          attachment,
        })

        const referral = this.item
        this.$store.dispatch('referrals/save', { ...referral, completed_time: now })
      } catch (er) {
        console.error(er)
      }
    },
  },
}
</script>

<style scoped lang="scss">
hr {
  border-color: var(--border-color);
  margin: 1.25rem 0;
}
h5 {
  text-transform: uppercase;
  font-size: 0.75rem;
  margin-bottom: 1.5rem;
  margin-top: 2rem;
}
.thumbnail-grid {
  margin: 1em 0;
  padding: 0;
  list-style: none;
  display: grid;
  grid: auto-flow / repeat(auto-fit, minmax(200px, 1fr));
  align-items: center;
  grid-gap: 1em;
  gap: 1em;
}
.thumbnail-grid li {
  padding: 10px;
  text-align: center;
  border: 1px solid #e8e8e8;
  background: #f4f4f4;
}
.thumbnail-grid li img {
  max-width: 100%;
}

.section-tabs {
  svg {
    cursor: pointer;
    &:hover {
      path {
        fill: var(--border-color);
      }
    }
  }
}

.hover-primary:hover {
  color: var(--primary-color);
  cursor: pointer;
  path {
    fill: var(--primary-color);
  }
}

.progress-indicator {
  display: flex;
  justify-content: space-between;
  margin: 0 1.5rem;
  > div {
    flex-grow: 1;
    flex-basis: 0;
    &:not(:last-child) {
      margin-right: 0.5rem;
    }

    // &:after {
    //   content: '';
    //   border-top: 20px solid transparent;
    //   border-bottom: 20px solid transparent; /* 40px height (20+20) */
    //   border-left: 20px solid var(--primary-color);
    //   right: -5px;
    //   top: -50px;
    //   z-index: 2;
    //   max-height: 20px;
    //   line-height: 20px;
    //   position: relative;
    //   // transform: translate(-50%);
    // }
    .circle {
      // border: 2px solid var(--border-color);
      color: #fff; // var(--light-color);
      border-radius: 50%;
      width: 48px;
      height: 48px;
      background: var(--border-color);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
    }
    h5 {
      margin-bottom: 0;
      text-transform: uppercase;
      font-weight: bold;
      letter-spacing: 0.5px;
      font-size: 0.725rem;
      white-space: nowrap;
      word-break: keep-all;
      color: var(--border-color);
    }
    &.active {
      .circle {
        background: var(--primary-color);
      }
      h5 {
        color: var(--primary-color);
      }
    }
  }
}
.bottom-bar {
  background: #cbd9d9de;
  display: flex;
  padding: 0.5rem 2rem;
  width: 100%;
  transition: background 0.5s ease-out;
  z-index: 8888;

  &:hover {
    background: var(--border-color);
  }
}
.fixed-alert {
  position: fixed;
  z-index: 99;
}
</style>